import { hydrateRoot } from "react-dom/client";

export default (container: any, root?: HTMLElement) => {
  if (!root) root = document.getElementById("__metablock") as HTMLElement;
  hydrateRoot(root, container);
};
